import { useLocalization } from "@tm/localization"

export function OrderAcceptance({ orderAcceptance }: { orderAcceptance?: Date }) {
    const { date } = useLocalization()
    if (!orderAcceptance) {
        return null
    }
    return <>{date(orderAcceptance, "g")}</>
}
